import React from 'react'
import { NumericFormat } from 'react-number-format'

const VentasDiscriminadas = ({ data }) => {

	return (
		<div className="row">
			{data.map((item, index) => {
				if (item.total > 0) {
					return (
						<div className="CajaInformeMenor" key={index}>
							<div className="row">
								<div className="col-md-9">
									<span>{item.cantidad} </span>
									<span>{item.nombre}</span>
								</div>
								<div className="col-md-3">
									<span className="derecha"><NumericFormat decimalScale={2} value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
								</div>
							</div>
						</div>
					)
				}
			})
			}
		</div>
	)


}



export default VentasDiscriminadas